<template>
    <div class="flex space-between mt-3 columnMobile">
        <div class="analiza-comp white-box">
            <div style="margin-bottom: 2rem">
                <span class="background-title">Analiză finanțare</span>
                <img src="@/assets/images/smis-logo-color.png" alt="" style="float: right;">
            </div>
            <p class="analiza-title">Companie</p>
            <p class="analiza-result">{{ termeneV3.nume }}</p>
            <p class="analiza-title">Status</p>
            <p class="analiza-result" :class="eligibilitate ? 'eligibil' : 'neeligibil'">{{ eligibilitate ? 'Companie eligibilă*' : 'Companie neeligibilă*' }}</p>
            <p class="analiza-title">Valoare maximă finanțare nerambursabilă</p>
            <b-spinner v-if="!maxBudget" style="width: 1.5rem; height: 1.5rem; font-size: 10px;"></b-spinner>
            <p v-else class="analiza-number" :class="eligibilitate ? 'eligibil' : 'neeligibil'">{{ maxBudget ? maxBudget.toLocaleString('ro-RO') : 0 }}€</p>
            <p class="analiza-title">Cofinanțare de la:</p>
            <b-spinner v-if="!maxBudget" style="width: 1.5rem; height: 1.5rem; font-size: 10px;"></b-spinner>
            <p v-else class="analiza-number">{{ calculateCoFinancing() }}€</p>
            <p class="analiza-title">Procent de scădere a cifrei de afaceri</p>
            <p class="analiza-number">{{ caPercent }}%</p>
            <p class="analiza-title">Punctaj maxim posibil</p>
            <p class="analiza-number mb-4" :class="eligibilitate ? 'eligibil' : 'neeligibil'">{{ data2.evaluation.score }}</p>
            <hr style="margin-bottom: 2.25rem; margin-top: 2.25rem">
            <div class="warn-text">
                <span style="font-weight: 800;">ATENȚIE!</span>
                <span style="font-size: 11px; display: block;">Analiza este realizată cu titlu de informare în baza informațiilor publice primite prin API de la instituțiile statului si prin comunicate MIPE. Vă rugăm să analizați personal eligibilitatea companiei și să urmăriți lansarea ghidul solicitantului în forma finală. Vă mulțumim!</span>
            </div>
        </div>
        <div class="eligibilitate-comp white-box">
            <span class="background-title">Eligibilitatea companiei</span>
            <ul style="margin-bottom: 1rem; margin-top: 1rem">
                <li>
                    <b-icon-check-circle-fill v-if="caMinim()" class="eligibil mr-2"></b-icon-check-circle-fill>
                    <b-icon-x-circle-fill v-else class="neeligibil mr-2"></b-icon-x-circle-fill>
                    <span style="font-weight: 700">Cifra de afaceri aferentă anului 2019 > 10.000 € (49.460 lei)</span>
                </li>
                <li>
                    <b-icon-check-circle-fill v-if="termeneV3 && termeneV3.vechime > 2" class="eligibil mr-2"></b-icon-check-circle-fill>
                    <b-icon-x-circle-fill v-else class="neeligibil mr-2"></b-icon-x-circle-fill>
                    <span style="font-weight: 700">Compania este înființată cel mai târziu la 31.12.2018</span>
                </li>
                <li>
                    <b-icon-check-circle-fill v-if="cifraAfaceri()" class="eligibil mr-2"></b-icon-check-circle-fill>
                    <b-icon-x-circle-fill v-else class="neeligibil mr-2"></b-icon-x-circle-fill>
                    <span v-if="cifraAfaceri()">Compania a înregistrat o scădere a Cifrei de Afaceri <span class="bold">>5%</span></span>
                    <span v-else>Compania <span class="red">nu</span> a înregistrat o scădere a Cifrei de Afaceri <span class="bold">>5%</span></span>
                </li>
                <li>
                    <b-icon-check-circle-fill v-if="caenEligibil(true) === 'eligibil' || caenEligibil(true) === 'gri'" class="eligibil mr-2"></b-icon-check-circle-fill>
                    <b-icon-x-circle-fill v-else class="neeligibil mr-2"></b-icon-x-circle-fill>
                    <span v-if="caenEligibil(true) === 'eligibil' || caenEligibil(true) === 'gri'">Compania deține CAEN principal eligibil</span>
                    <span v-else>Compania <span class="red">nu</span> deține CAEN principal eligibil</span>
                </li>
<!--                <li>
                    <b-icon-check-circle-fill v-if="checkProfit()" class="eligibil mr-2"></b-icon-check-circle-fill>
                    <b-icon-x-circle-fill v-else class="neeligibil mr-2"></b-icon-x-circle-fill>
                    <span style="font-weight: 700">Compania a înregistrat profit în anul 2019 </span>
                </li>-->
<!--                <li>-->
<!--                    <b-icon-check-circle-fill v-if="data.CA_2020 && Number(data.CA_2020) > 0" class="eligibil mr-2"></b-icon-check-circle-fill>-->
<!--                    <b-icon-x-circle-fill v-else class="neeligibil mr-2"></b-icon-x-circle-fill>-->
<!--                    <span style="font-weight: 700">Compania nu a avut activitatea suspendată în anul 2020</span>-->
<!--                </li>-->

                <li>
                    <b-icon-check-circle-fill v-if="secundareEligibile > 0" class="eligibil mr-2"></b-icon-check-circle-fill>
                    <b-icon-x-circle-fill v-else class="neeligibil mr-2"></b-icon-x-circle-fill>
                    <span v-if="secundareEligibile === 0">Compania <span class="bold neeligibil">nu</span> deține coduri CAEN secundare eligibile</span>
                    <span v-else>Compania deține <span class="bold">{{ secundareEligibile }}</span> coduri CAEN secundare eligibile</span>
                </li>

                <li>
                    <b-icon-check-circle-fill v-if="caenSold()" class="eligibil mr-2"></b-icon-check-circle-fill>
                    <b-icon-x-circle-fill v-else class="mr-2"></b-icon-x-circle-fill>
                    <span>Cod CAEN principal sold negativ (INS)*</span>
                </li>
                <li>
                    <b-icon-check-circle-fill v-if="secCaenEligibil().length >= 5" class="eligibil mr-2"></b-icon-check-circle-fill>
                    <b-icon-x-circle-fill v-else class="mr-2"></b-icon-x-circle-fill>
                    <span>Cod CAEN secundar sold negativ (INS)* - pentru 5 coduri</span>
                </li>
                <li>
                    <b-icon-check-circle-fill v-if="checkImmType()" class="eligibil mr-2"></b-icon-check-circle-fill>
                    <b-icon-x-circle-fill v-else class="neeligibil mr-2"></b-icon-x-circle-fill>
                    <span>Compania este IMM <small v-if="!checkImmType()" style="font-weight: 600;">( {{ immReason }} )</small></span>
                </li>
<!--                <li :class="hasNegativeCapital ? 'capital2019Negativ' : ''">
                    <b-icon-info-circle-fill class="infoPoint mr-2"></b-icon-info-circle-fill>
                    <span style="color: #01aef0">Verifică: <span style="color: #3b4369;"> Solicitantul <span v-show="!hasNegativeCapital">nu</span> este întreprindere în dificultate în anul 2019</span></span>
                </li>-->
            </ul>
            <div class="gray-divider"><p>*Verificări suplimentare necesare</p></div>
            <ul style="margin-bottom: 1rem; margin-top: 1rem" class="custom-list">
                <li>
                    <div class="verify-text">
                        <img src="@/assets/images/M3/M3Sketch/warn.png" class="title-icon">
                        <p><span class="yellow-text">Verifică:</span> Solicitantul nu este întreprindere în dificultate în anul 2019</p>
                    </div>
                    <div class="verify-info">
                        <b-icon-info-circle-fill class="infoPoint mr-2"></b-icon-info-circle-fill>
                        <p>
                            Capitalul la 2019 este
                            <span v-if="getData2019('capital') < 0" class="red-text-bold">negativ {{ getData2019('capital') }} lei</span>
                            <span v-else class="green-text-bold">pozitiv {{ getData2019('capital') }}  lei</span>
                        </p>
                    </div>
                </li>
                <li>
                    <div class="verify-text">
                        <img src="@/assets/images/M3/M3Sketch/warn.png" class="title-icon">
                        <p><span class="yellow-text">Verifică:</span> Solicitantul a obținut profit din <strong>exploatare</strong> în anul 2019 (bilanț)</p>
                    </div>
                    <div class="verify-info">
                        <b-icon-info-circle-fill class="infoPoint mr-2"></b-icon-info-circle-fill>
                        <p>
                            Profitul sau pierderea <strong>brut(ă)</strong> 2019:
                            <span v-if="getData2019('profit').pierdere" class="red-text-bold">pierdere: {{ getData2019('profit').pierdere }} lei</span>
                            <span v-else class="green-text-bold">profit {{ getData2019('profit').profit }}  lei</span>
                        </p>
                    </div>
                </li>
            </ul>
            <hr style="margin-bottom: 2.25rem; margin-top: 1.5rem">
            <span style="color: #b1b3bf!important"><span style="font-weight: 800">ATENȚIE!</span> <span style="font-size: 11px; display: block;">Vă rugăm să analizați personal eligibilitatea companiei în conformitate cu ghidul solicitantului, împreună cu contabilul companiei sau un consultant specializat. În cazul în care există informații lipsă, analiza nu va fi returnată în mod corect. Statusul de companie NE/ELIGIBILĂ nu atrage după sine răspunderea platformei Smis.</span> </span>
        </div>
    </div>
</template>

<script>
    import {BIconCheckCircleFill, BIconXCircleFill, BIconInfoCircleFill, BSpinner} from 'bootstrap-vue'
    import M3StatisticiCharts from './M3StatisticiCharts'
    import listaCaen from '@/pages/Aplicatii/M3/caen_eligibil.json';
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import _ from "lodash";
    export default {
        components: {
            BIconCheckCircleFill,
            BIconXCircleFill,
            BIconInfoCircleFill,
            M3StatisticiCharts,
            BSpinner
        },
        props: {
            data: null,
            data2: null,
            termeneV3: null,
            eligibilitate: null,
            caPercent: null,
			hasNegativeCapital: null,
        },
        data() {
            return {
                secundareEligibile: null,
                maxBudget: null,
                statistici: null,
                immReason: null,
                help_moneyM1: null,
                help_moneyM2: null,
                help_moneyHoreca: null,
                sumLoading: false,
            };
        },
        computed: {
            stateAids() {
                return this.$store.getters['stateAids/getStateAids']
            }
        },
        mounted() {
            this.sumLoading = true
            this.eligibilitateCaen
            this.eligibilitateSecundare()
            this.checkMaxFinancing()
            this.checkEligibleFinal()
        },
        methods: {
            caenEligibil(isPrimary) {
                let eligibil
                if (isPrimary) {
                    eligibil = _.filter(listaCaen, v => v.caen === this.data.codCaenPrincipalRecom[0].cod_caen)
                } else {
                    let caenSecundare = _.map(this.data.coduriCaenSecundare, 'cod_caen_secundar')
                    eligibil = _.intersectionWith(listaCaen.map(v => v.caen), caenSecundare);
                }

                if (eligibil.length === 0) {
                    // Rosu
                    return 'neeligibil'
                } else if (eligibil[0].eligibil === "negativ") {
                    // Verde
                    return 'eligibil'
                } else if (eligibil[0].eligibil === 'pozitiv' || eligibil[0].eligibil === "necunoscut") {
                    return 'gri'
                }
            },
            checkImmType() {
                if (this.data.CA_2020 > 250000000 || this.data.nr_angajati_2020 > 250) {
                    this.$emit('notEligibleImm')
                    if (this.data.CA_2020 > 250000000 && this.data.nr_angajati_2020 < 250) {
                        this.immReason = 'Cifra de afaceri depășește 250.000.000 lei'
                    } else if (this.data.nr_angajati_2020 > 250 && this.data.CA_2020 < 250000000) {
                        this.immReason = 'Compania are peste 250 de angajați'
                    } else {
                        this.immReason = 'Compania are peste 250 de angajați și cifra de afaceri depășește 250.000.000 lei'
                    }
                    return false
                } else {
                    return true
                }
            },
            secCaenEligibil() {
                let caenSecundare = _.map(this.data.coduriCaenSecundare, 'cod_caen_secundar')
                let find = _.filter(listaCaen, function (obj) {
                    if (caenSecundare.includes(obj.caen)) {
                        return obj;
                    }
                })
                return find
            },
            eligibilitateCaen() {
                if (_.filter(listaCaen, v => v.caen === this.data.codCaenPrincipalRecom[0].cod_caen).length > 0) {
                    return 'eligibil'
                } else {
                    return 'neeligibil'
                }
            },
            eligibilitateSecundare() {
                let caenSecundare = _.map(this.data.coduriCaenSecundare, 'cod_caen_secundar')
                if (_.intersectionWith(listaCaen.map(v => v.caen), caenSecundare).length > 0) {
                    this.secundareEligibile = _.intersectionWith(listaCaen.map(v => v.caen), caenSecundare).length
                }
            },
            cifraAfaceri() {
                let vechi = this.data.CA_2019
                let nou = this.data.CA_2020
                let difference = (vechi - nou) * 100 / vechi
                if (!nou) {
                    nou = 0;
                }
                if (!vechi || vechi < nou) {
                    return false
                } else if (difference <= 5) {
                    return false
                } else {
                    return true
                }
            },
            checkStateAids() {
                let ajutorM1;
                let ajutorM2;
                let ajutorHoreca;
                if (this.data2 && this.data2.cui) {
                    ajutorM1 = this.stateAids.m1
                    ajutorM2 = this.stateAids.m2
                    ajutorHoreca = this.stateAids.horeca
                }

                if (ajutorM1) {
                    if (ajutorM1['Status contract'] === 'Contract platit' || ajutorM1['Status contract'] === 'Contract semnat') {
                        this.help_moneyM1 = '9679'
                    } else {
                        this.help_moneyM1 = null
                    }
                }

                if (ajutorM2) {
                    if (ajutorM2['Status contract'] !== 'Contract respins' && ajutorM2['Status contract'] !== 'Respins in lista de asteptare' && ajutorM2['Status contract'] !== 'Respins In lista de asteptare') {
                        this.help_moneyM2 = ajutorM2['Suma solicitata']
                    } else {
                        this.help_moneyM2 = null
                    }
                }
                if (ajutorHoreca) {
                    if (ajutorHoreca.Status === 'Aprobată') {
                        this.help_moneyHoreca = ajutorHoreca['Suma solicitata']
                    } else {
                        this.help_moneyHoreca = null
                    }
                }
            },
            checkMaxFinancing() {
                this.checkStateAids()
                this.formSend = {
                    m1: this.help_moneyM1 ? (Number(this.help_moneyM1) / 4.8395).toFixed(0) : 0,
                    m2: this.help_moneyM2 ? (Number(this.help_moneyM2) / 4.8395).toFixed(0) : 0,
                    horeca: this.help_moneyHoreca ? (Number(this.help_moneyHoreca) / 4.9260).toFixed(0) : 0,
                    ca: Number(this.data.CA_2019 / 4.946).toFixed(0)
                }
                axios.post(api.API_ENDPOINTS.m3MaxBudget, this.formSend)
                    .then(response => {
                        this.maxBudget = Number(response.data.budget).toFixed(0)
                        this.$emit('MaxFinancing', this.maxBudget)
                    })
            },
            calculateCoFinancing() {
                if (this.data2 && this.data2.cofinancing) {
                    this.$emit('cofinanceValue', ((this.data2.cofinancing / 100) * Number(this.maxBudget)).toFixed(0))
                    return ((this.data2.cofinancing / 100) * Number(this.maxBudget)).toFixed(0)
                } else if(this.data2 && this.data2.cofinancing === 0) {
                    this.$emit('cofinanceValue', ((5 / 100) * Number(this.maxBudget)).toFixed(0))
                    return ((5 / 100) * Number(this.maxBudget)).toFixed(0)
                }
            },
            caenSold() {
                let sold = _.filter(listaCaen, v => v.caen === this.data.codCaenPrincipalRecom[0].cod_caen)
                if (sold[0]) {
                    if (sold[0].eligibil === 'negativ') {
                        return true
                    } else {
                        return false
                    }
                }
            },
            checkProfit() {
                let bilant2019 = null
                if (this.termeneV3 && this.termeneV3.bilant_scurt && this.termeneV3.bilant_scurt.length > 0) {
                    bilant2019 = _.filter(this.termeneV3.bilant_scurt, v => v.an === 2019);
                }
                if (bilant2019 && bilant2019[0]) {
                    return bilant2019[0].profit_net > 0;
                }
            },
            getData2019(type) {
                let bilant2019 = null
                if (this.termeneV3 && this.termeneV3.bilant_scurt && this.termeneV3.bilant_scurt.length > 0) {
                    bilant2019 = _.filter(this.termeneV3.bilant_scurt, v => v.an === 2019);
                }
                if (bilant2019 && bilant2019[0]) {
                    if(type === 'capital') {
                        return bilant2019[0].capital_total
                    } else if(type === 'profit') {
                        if(bilant2019[0].profit_brut > 0) {
                            return { profit: bilant2019[0].profit_brut}
                        } else {
                            return { pierdere: bilant2019[0].pierdere_brut }
                        }
                    }
                }
            },
            caMinim() {
                let caMinim2019 = _.filter(this.termeneV3.bilant_scurt, v => v.an === 2019);
                let cursEuro = 4.946
                if (caMinim2019[0]) {
                    return (caMinim2019[0].cifra_de_afaceri_neta / cursEuro) >= 10000;
                }
            },
            checkEligibleFinal() {
                if (this.caMinim()
                    && (this.termeneV3 && this.termeneV3.cod_inmatriculare && Number(this.termeneV3.cod_inmatriculare.slice(this.termeneV3.cod_inmatriculare.length - 4)) < 2019)
                    /*&& this.checkProfit()*/
                    // && (this.data.CA_2020 && Number(this.data.CA_2020) > 0)
                    && this.cifraAfaceri()
                    && this.checkImmType()
                ) {
                    this.$emit('eligibleCompany')
                }
            },
        }
    }
</script>

<style scoped>
.flex{
    display: flex;
}
.white-box{
    background: #ffffff;
    padding: 15px;
}
.gray-divider{
    background: #f0f0f0;
    min-height: 40px;
    margin: 0 -15px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}
.gray-divider p{
    font-size: 17px;
    color: #3b4369;
}
.space-between{
    justify-content: space-between;
}
.caen-principal{
    width: 29%;
}
.eligibilitate-comp{
    width: 53%;
}
.analiza-comp{
    width: 45.5%;
}
.bold{
    font-weight: 600 !important;
}
.background-title{
    border: 1px solid #e5e5e9;
    background: #f1f1f4;
    color: #3b4369;
    font-size: 12px;
    padding: 4px 3px;
    font-weight: 600;
}
.caen{
    font-size: 23px;
    color: #3b4369;
    font-weight: inherit;
    padding: 13px 0;
}
.eligibil{
    font-weight: 700 !important;
    color: #46cca6 !important;
}
.neeligibil{
    font-weight: 700 !important;
    color: #ff6767 !important;
}
.capital2019Negativ{
	animation: blinker 4s linear infinite;
}
.capital2019Negativ,
.capital2019Negativ *{
	color: #ff6767 !important;
}
@keyframes blinker {
	50% {
		opacity: .3;
	}
}
.infoPoint{
  color: #01aef0;
}
.caen-principal ul:not(.custom-list){
    display: flex;
    flex-wrap: wrap;
    max-height: 225px;
    overflow: auto;
}
.custom-list li{
    flex-direction: column;
}
.verify-text, .verify-info{
    width: 100%;
    display: inline-flex;
    align-items: center;
}
.verify-info p, .verify-text p{
    font-size: 13px;
}
.verify-info{
    margin-left: 80px;
}
.yellow-text{
    color: #fdb71b !important;
}
.red-text-bold{
    font-weight: bold !important;
    color: var(--dangerColor) !important;
}
.green-text-bold{
    font-weight: bold !important;
    color: var(--succesColor) !important;
}
.caen-principal li{
    padding-right: 10px;
}
.caen-small{
    font-size: 16px;
    color: #3b4369;
    font-weight: inherit;
    padding: 13px 0;
}
.eligibilitate-comp li span{
    font-weight: 300;
    font-size: 13px;
    color: #3b4369;
}
.bullet-bg-green, .bullet-bg-blue, .bullet-bg-red{
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    position: relative;
}
.bullet-bg-green{
    background: #46cca6;
}
.bullet-bg-blue{
    background: #3b4369;
}
.bullet-bg-red{
    background: #ff6767;
}
.bullet{
    position: absolute;
    display: block;
    border-radius: 50%;
    background: #fff;
    width: 5px;
    height: 5px;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
}
.caen-status span{
    font-size: 10px;
    color: #3b4369;
}
.eligibilitate-comp svg{
    font-size: 14px;
}
.eligibilitate-comp li{
    align-items: center;
    display: flex;
}
.eligibilitate-comp li span{
    line-height: 2;
}
.caen-status{
    margin: 15px 0;
}
.bullet-bg-green, .bullet-bg-red, .bullet-bg-blue{
    width: 9px;
    height: 9px;
    margin-top: 2px;
}
.infoLinks{
    color: #ffffff;
    text-decoration: none;
    cursor: pointer;
    margin-left: 10px;
    padding: 2px 10px;
    border-radius: 4px;
    max-height: 30px;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.govLinks{
    background-color: #004990;
}
.smisLinks{
    background-color: #5c659d;
}
.infoContainer{
    display: flex;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 5px;
}
.infoContainer img{
    max-height: 30px;
}
.infoDescription{
    color: #84889b;
    font-size: 12px;
    margin-top: 5px;
}
.analiza-title{
    font-size: 13px;
    margin-top: 10px;
    color: #3b4369;
}
.analiza-result{
    font-size: 17px;
    font-weight: 800;
}
.analiza-number{
    font-size: 22px;
    font-weight: 800;
}
.warn-text{
    color: rgb(177, 179, 191) !important;
}
@media (max-width: 1550px){
    .caen-principal, .eligibilitate-comp, .analiza-comp{
        width: 100%;
        margin-top: 1rem;
    }
    .columnMobile{
        flex-direction: column;
    }
}
@media only screen and (max-width: 420px) {
  .eligibilitate-comp ul li {
    align-items: flex-start;
    margin-bottom: 15px;
  }
  .eligibilitate-comp ul li span {
    line-height: 1;
  }
}

</style>
